export class SetPendingSave {
  static readonly type = '[ClassificationState] SetPendingSave';

  constructor(public readonly pendingSave: boolean) {}
}
